// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 350px;
  height: 500px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 250px;
  min-height: 300px;
  max-width: 90vw;
  max-height: 90vh;
}

.chat-resizer {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  cursor: nwse-resize;
  z-index: 10;
  /* Visual styling: a pattern or background that indicates resizable area */
  background: repeating-linear-gradient(
    45deg,
    #ccc,
    #ccc 2px,
    white 2px,
    white 4px
  );
  border: 1px solid #999;
  border-radius: 3px;
}

/* Optional: additional styling for an inner handle if using .resize-handle */
.resize-handle {
  width: 100%;
  height: 100%;
  background: transparent;
}

.chat-close-button {
  background-color: #ff4d4d;  /* A red background for visibility */
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
}

.chat-close-button:hover {
  background-color: #e60000;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border-bottom: 1px solid #ccc;
}

.chat-close-button {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.chat-close-button:hover {
  color: #ffcccc;
}

.chat-window {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #f7f7f7;
}

.chat-message {
  margin: 5px 0;
  padding: 8px;
  border-radius: 5px;
}

.chat-message-self {
  background-color: #d4f7d4; /* Green for self */
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 5px;
  align-self: flex-end;
}

.chat-message-other {
  background-color: #d0e6ff; /* Blue for others */
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 5px;
  align-self: flex-start;
}

.chat-input-container {
  display: flex;
  padding: 10px;
  background-color: #fff;
  border-top: 1px solid #ccc;
}

.chat-input {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.chat-send-button {
  padding: 8px 16px;
  margin-left: 8px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.chat-send-button:hover {
  background-color: #0056b3;
}
.chat-notification {
  background-color: #f8d7da; /* Light red for warning */
  color: #721c24; /* Darker red for contrast */
  border: 1px solid #f5c6cb;
  padding: 10px;
  margin: 10px 0;
  text-align: center;
  border-radius: 4px;
  font-weight: bold;
}
.chat-message-system {
  color: red;
  font-style: italic;
}
.chat-header-logo {
  width: auto;
  height: 80px; /* Adjust height as needed */
  margin-left: 10px; /* Add spacing */
}

.emoji-picker-container {
  position: absolute;
  bottom: 60px; /* Adjust based on input field height */
  right: 10px; /* Align with the emoji button */
  z-index: 2000;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}
.chat-message {
  margin: 5px 0;
  padding: 8px;
  border-radius: 5px;
  max-width: 95%; /* Prevents messages from spanning the full width */
  word-wrap: break-word; /* Ensures long words break properly */
  overflow-wrap: break-word; /* Breaks words that don't fit */
  white-space: pre-wrap; /* Ensures new lines are respected */
}
`, "",{"version":3,"sources":["webpack://./src/Chat/ChatApp.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,0EAA0E;EAC1E;;;;;;GAMC;EACD,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,GAAG,oCAAoC;EAChE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,4BAA4B;EAC5C,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY,EAAE,4BAA4B;EAC1C,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,uCAAuC;EACrD,WAAW,EAAE,gCAAgC;EAC7C,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc,EAAE,mDAAmD;EACnE,qBAAqB,EAAE,sCAAsC;EAC7D,yBAAyB,EAAE,gCAAgC;EAC3D,qBAAqB,EAAE,oCAAoC;AAC7D","sourcesContent":[".chat-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 350px;\n  height: 500px;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-width: 250px;\n  min-height: 300px;\n  max-width: 90vw;\n  max-height: 90vh;\n}\n\n.chat-resizer {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: nwse-resize;\n  z-index: 10;\n  /* Visual styling: a pattern or background that indicates resizable area */\n  background: repeating-linear-gradient(\n    45deg,\n    #ccc,\n    #ccc 2px,\n    white 2px,\n    white 4px\n  );\n  border: 1px solid #999;\n  border-radius: 3px;\n}\n\n/* Optional: additional styling for an inner handle if using .resize-handle */\n.resize-handle {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n\n.chat-close-button {\n  background-color: #ff4d4d;  /* A red background for visibility */\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 18px;\n  line-height: 32px;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.2s ease;\n}\n\n.chat-close-button:hover {\n  background-color: #e60000;\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background-color: #007bff;\n  color: white;\n  border-bottom: 1px solid #ccc;\n}\n\n.chat-close-button {\n  background-color: transparent;\n  border: none;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.chat-close-button:hover {\n  color: #ffcccc;\n}\n\n.chat-window {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n  background-color: #f7f7f7;\n}\n\n.chat-message {\n  margin: 5px 0;\n  padding: 8px;\n  border-radius: 5px;\n}\n\n.chat-message-self {\n  background-color: #d4f7d4; /* Green for self */\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 5px;\n  align-self: flex-end;\n}\n\n.chat-message-other {\n  background-color: #d0e6ff; /* Blue for others */\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 5px;\n  align-self: flex-start;\n}\n\n.chat-input-container {\n  display: flex;\n  padding: 10px;\n  background-color: #fff;\n  border-top: 1px solid #ccc;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.chat-send-button {\n  padding: 8px 16px;\n  margin-left: 8px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.chat-send-button:hover {\n  background-color: #0056b3;\n}\n.chat-notification {\n  background-color: #f8d7da; /* Light red for warning */\n  color: #721c24; /* Darker red for contrast */\n  border: 1px solid #f5c6cb;\n  padding: 10px;\n  margin: 10px 0;\n  text-align: center;\n  border-radius: 4px;\n  font-weight: bold;\n}\n.chat-message-system {\n  color: red;\n  font-style: italic;\n}\n.chat-header-logo {\n  width: auto;\n  height: 80px; /* Adjust height as needed */\n  margin-left: 10px; /* Add spacing */\n}\n\n.emoji-picker-container {\n  position: absolute;\n  bottom: 60px; /* Adjust based on input field height */\n  right: 10px; /* Align with the emoji button */\n  z-index: 2000;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n}\n.chat-message {\n  margin: 5px 0;\n  padding: 8px;\n  border-radius: 5px;\n  max-width: 95%; /* Prevents messages from spanning the full width */\n  word-wrap: break-word; /* Ensures long words break properly */\n  overflow-wrap: break-word; /* Breaks words that don't fit */\n  white-space: pre-wrap; /* Ensures new lines are respected */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
